import { FormField } from '@/types';
import RadioGroup from '@components/Form/RadioGroup';

function RadioField(props: FormField) {
  const {
    label,
    clean_name: cleanName,
    choices,
    required,
    setCurrentSelected,
    isCustomForm,
  } = props;

  const separator = choices.includes('\r\n') ? '\r\n' : ',';

  return (
    <RadioGroup
      id={cleanName}
      row={!choices.includes('\r\n') && !isCustomForm}
      label={label}
      setCurrentSelected={setCurrentSelected}
      items={choices.split(separator).map(choice => ({ label: choice }))}
      required={required}
    />
  );
}

export default RadioField;
